import * as  ActionTypes from "../../Actions/DriverLog/ActionTypes"
import * as ActionReducer from "./ActionReducer"

const initialState = {
  getDriverLog: {
    request: null,
    response: null,
    error: null,
  },
};

const DriverLogReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_DRIVER_LOG:
      return ActionReducer.getDriverLog(state, action);
    case ActionTypes.GET_DRIVER_LOG_SUCCESS:
      return ActionReducer.getDriverLogSuccess(state, action);
    case ActionTypes.GET_DRIVER_LOG_FAIL:
      return ActionReducer.getDriverLogFail(state, action);

    default:
      return state;
  }
};

export { DriverLogReducer };
